import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tab, Row, Col, Nav, NavItem } from 'react-bootstrap';
import ProjectDocumentSection from 'Projects/Components/Document/home-document-section';
import * as LotActionType from '../constants';

class HomeDocument extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    HomeownerLotSelectList: PropTypes.array,
    HomeownerDocumentTypes: PropTypes.array,
    lot: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      activeKey: '1',
      lot: null
    };
  }

  /* fetchListDocumentType = () => {
    const { lot } = this.props;
    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_LIST_HOMEOWNER_DOCUMENT_TYPE_ASYNC,
      params: {
        endpoint: builderProfile.lotSharedDocumentTypesEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        },
        lotId: lot.value
      }
    });
  }; */

  render() {
    const { HomeownerDocumentTypes } = this.props;
    const { lot } = this.props;
    const { activeKey } = this.state;

    if (lot) {
      return (
        <div id='manage-homeowner-manual'>
          <div
            className='project-document-wrapper box-form-siteone'
            style={{ padding: 25 }}
          >
            <div>
              <Tab.Container
                id='left-tabs-example'
                className='s1-stack-tab'
                activeKey={activeKey}
                onSelect={key => this.setState({ activeKey: key })}
              >
                <Row className='clearfix'>
                  <Col sm={2} style={{ paddingRight: 0 }}>
                    <div className='project-documents-group-tabs-title'>
                      Documents
                    </div>
                    <Nav bsStyle='pills' stacked>
                      {HomeownerDocumentTypes.filter(
                        x => x.extensionValue.documentType === 0
                      ).map(type => {
                        const typeIndex = HomeownerDocumentTypes.indexOf(type);
                        return (
                          <NavItem
                            eventKey={typeIndex.toString()}
                            key={typeIndex}
                          >
                            {type.text}
                          </NavItem>
                        );
                      })}
                    </Nav>
                    <div
                      className='project-documents-group-tabs-title'
                      style={{ marginTop: 40 }}
                    >
                      Videos
                    </div>
                    <Nav bsStyle='pills' stacked>
                      {HomeownerDocumentTypes.filter(
                        x => x.extensionValue.documentType === 1
                      ).map(type => {
                        const typeIndex = HomeownerDocumentTypes.indexOf(type);
                        return (
                          <NavItem eventKey={typeIndex.toString()} key={typeIndex} >
                            {type.text}
                          </NavItem>
                        );
                      })}
                    </Nav>
                  </Col>
                  <Col sm={10}>
                    <Tab.Content
                      animation
                      style={{
                        paddingLeft: 15,
                        paddingRight: 15,
                        border: '1px solid #e6e6e6',
                        backgroundColor: '#fff',
                        minHeight: 255
                      }}
                    >
                      {HomeownerDocumentTypes.map((type, index) => {
                        return (
                          <Tab.Pane eventKey={index.toString()} key={index}>
                            <ProjectDocumentSection
                              hidden={activeKey !== index.toString()}
                              lot={lot}
                              documentTypeId={type.value}
                              manualType={type.extensionValue.documentType}
                            />
                          </Tab.Pane>
                        );
                      })}
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    HomeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
    HomeownerDocumentTypes: state.LotStore.HomeownerDocumentTypes
  };
};

export default connect(mapStateToProps)(HomeDocument);



// WEBPACK FOOTER //
// ./src/Lots/Containers/home-hub-home-documents.js